const STORAGE_KEY = "rw-recently-viewed";
const MAX_ITEMS = 8;

/**
 * Add a product slug to the recently viewed list in localStorage.
 * Most recent item is first. Duplicates are moved to the front.
 */
export function addRecentlyViewed(slug: string): void {
  if (typeof window === "undefined") return;

  try {
    const existing = getRecentlyViewed();
    const filtered = existing.filter((s) => s !== slug);
    const updated = [slug, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage may be unavailable (private browsing, quota exceeded, etc.)
  }
}

/**
 * Get the list of recently viewed product slugs from localStorage.
 * Most recent item is first.
 */
export function getRecentlyViewed(): string[] {
  if (typeof window === "undefined") return [];

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === "string").slice(0, MAX_ITEMS);
  } catch {
    return [];
  }
}
